import moment from "moment";
import { BaseSalesDTO, SalesWithAreaDTO } from "../services/sales.interface";
import { VehicleMappedDTO } from "../hooks/useSalesDashboard";
import { ColumnsType } from "antd/lib/table";
import { TableColumn } from "../../common/table/TableBase";
import { KRW } from "../../common/text/DashboardFormmat";
import { Typography } from "antd";

export function isAvailableDate(date: moment.Moment) {
  const targetDate = moment("2022-07-30", "YYYY-MM-DD");
  const inputDate = moment(date);

  return inputDate.isSameOrAfter(targetDate);
}

export function isWeekend(date: number) {
  const day = moment(date).day();
  const isWeekend = day === 0 || day === 6;
  if(isWeekend) {
    if(day === 0) {
      return '#ff4d4f'
    } else {
      return '#1890ff'
    }
  }
  return '#000000'
}

export function aggregateSalesBySido(salesArray: SalesWithAreaDTO[]): VehicleMappedDTO[] {
  const aggregation = {};

  salesArray.forEach(sale => {
    if (!aggregation[sale.startAreaSidogungu]) {
      aggregation[sale.startAreaSidogungu] = { ...sale, vehicles: [sale] };
    } else {
      const aggSale = aggregation[sale.startAreaSidogungu];
      
      // 숫자 필드 합산, 단순히 더하는애들
      const sumFields = [
        'deployedCount', 'usableCount', 'usedCount', 'rideCount',
        'totalBillAmount', 'totalDiscountAmount', 'totalPaymentAmount',
        'discountCouponAmount', 'discountSwingPlusAmount', 'discountRewardAmount',
        'discountTransferAmount', 'discountOtherAmount'
      ] as const;
      
      sumFields.forEach(field => {
        aggSale[field] = (aggSale[field] || 0) + (sale[field] || 0);
      });
      
      // 계산된 값 업데이트
      aggSale.usedRatio = aggSale.usableCount > 0 ? (aggSale.usedCount / aggSale.usableCount) : 0;
      aggSale.revenuePerRide = aggSale.rideCount > 0 ? (aggSale.totalPaymentAmount / aggSale.rideCount) : 0;
      aggSale.revenuePerVehicle = aggSale.deployedCount > 0 ? (aggSale.totalPaymentAmount / aggSale.deployedCount) : 0;
      
      aggSale.vehicles.push(sale);
    }
  });

  return Object.values(aggregation);
}

export const extraColumns: ColumnsType<BaseSalesDTO> = [
  TableColumn(`쿠폰 할인`, row => <Typography.Text type={'danger'}>{KRW(row.discountCouponAmount)}</Typography.Text>, { align: 'right', sorter: () => 0, key: "discountCouponAmount", }),
  TableColumn(`스윙+ 할인`, row => <Typography.Text type={'danger'}>{KRW(row.discountSwingPlusAmount)}</Typography.Text>, { align: 'right', sorter: () => 0, key: "discountSwingPlusAmount" }),
  TableColumn(`리워드 할인`, row => <Typography.Text type={'danger'}>{KRW(row.discountRewardAmount)}</Typography.Text>, { align: 'right', sorter: () => 0, key: "discountRewardAmount" }),
  TableColumn(`환승 할인`, row => <Typography.Text type={'danger'}>{KRW(row.discountTransferAmount)}</Typography.Text>, { align: 'right', sorter: () => 0, key: "discountTransferAmount" }),
  TableColumn(`기타 할인`, row => <Typography.Text type={'danger'}>{KRW(row.discountOtherAmount)}</Typography.Text>, { align: 'right', sorter: () => 0, key: "discountOtherAmount" })
];